module.exports = __webpack_public_path__ + "static/connect-16fa1ffcc501e76f22f08e94825acb25.mp4";